import { useState, useEffect } from 'react'
import { supabase } from './supabaseClient'
import Auth from './screens/Auth'
import Dashboard from './screens/Dashboard'
import Onboarding from './screens/Onboarding'
import Landing from './screens/Landing'

export default function App() {
  const [session, setSession] = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [showAuth, setShowAuth] = useState(false)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) loadProfile(session.user.id)
      else setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) loadProfile(session.user.id)
      else {
        setProfile(null)
        setLoading(false)
        setShowAuth(false)
      }
    })

    return () => subscription.unsubscribe()
  }, [])

  async function loadProfile(userId) {
    const { data } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single()

    setProfile(data)
    setLoading(false)
  }

  if (loading) return (
    <div style={styles.loading}>⚓</div>
  )

  if (!session && !showAuth) return (
    <Landing onGetStarted={() => setShowAuth(true)} />
  )

  if (!session && showAuth) return (
    <Auth />
  )

  if (!profile?.behavior) return (
    <Onboarding session={session} onComplete={() => loadProfile(session.user.id)} />
  )

  return <Dashboard session={session} />
}

const styles = {
  loading: {
    minHeight: '100vh',
    background: '#080812',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 48,
  },
}